import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class SucursalService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          sucursal {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  codigo
                  nombre
                  descripcion
                  activo
                  fecha_creacion
                }
              }
            }
          }
        }        
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.sucursal.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSucursalxEmpresa(inputParams: {
    rut_empresa: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rut_empresa: Decimal) {
          sucursal {
            obtenerSucursalxEmpresa(rut_empresa: $rut_empresa) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  codigo
                  nombre
                  descripcion
                  activo
                  fecha_creacion
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.sucursal.obtenerSucursalxEmpresa
        callback({ mensajes, respuesta })
      }
    );
  }
}
